import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { DEPARTURE_REPORT_ENDPOINT } from '../endpoint';
import { DepartureReportRequestModel } from '../models/DepartureReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: DepartureReportRequestModel): Promise<void> => {
    return await axios
      .get(`${DEPARTURE_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'departure-report',
        });
      });
  };
